import { render, staticRenderFns } from "./GoodsVideoDesign.vue?vue&type=template&id=0df213f2&scoped=true&"
import script from "./GoodsVideoDesign.vue?vue&type=script&lang=js&"
export * from "./GoodsVideoDesign.vue?vue&type=script&lang=js&"
import style0 from "./GoodsVideoDesign.vue?vue&type=style&index=0&id=0df213f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df213f2",
  null
  
)

export default component.exports